var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"map container"},[_c('CultureQuestion',{attrs:{"currentFilter":_vm.currentFilter},on:{"onChangeFilter":_vm.onChangeFilter}}),_c('div',{staticClass:"map__itemContainer"},_vm._l((_vm.mapFilterList),function(mapItem){return _c('MapItem',{key:mapItem.smId,attrs:{"item":mapItem}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }